import { render, staticRenderFns } from "./FullView.vue?vue&type=template&id=50e942e6&"
import script from "./FullView.vue?vue&type=script&lang=js&"
export * from "./FullView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports